module.exports = __webpack_public_path__ + "img/bg-1.78ed2040.jpg";